import React from "react";
import Modal from "components/Modal";

interface IProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  title: string;
  content: string | React.ReactNode;
}

export default function TipModal({ isModalOpen, toggleModal, title, content }: Readonly<IProps>) {
  return (
    <Modal
      isOpen={isModalOpen}
      closeModal={toggleModal}
      wrapperClass="!my-auto desktop:!min-h-fit desktop:!w-1/2"
      dialogClass="!bg-foreground !gap-3 !pt-8">
      <h3 className="pl-3 text-2xl">{`Pro Tip: ${title}`}</h3>
      {content}
    </Modal>
  );
}
